import React from 'react';
import './diceTrack.css';

export const DiceResultCube = ({ value, className = '', testid, animating = false }) => <div className={`dice-result-cube ${className}`} data-testid={testid} data-animating={animating}>
  <span className="dice-cube-top" /><span className="dice-cube-left" /><span className="dice-cube-right" />
  <strong data-testid={`${testid}-value`}>{value.toFixed(2)}</strong>
</div>;